import React from 'react'
import Carousel from '@components/carousel'
import Hero from '@components/hero'
import { isVisibleIn } from '@src/utils/region'
import { useSiteSettingsStore } from "@src/hooks/useStore"

const HeroSlider = ({ slides, title, sliderSettings }) => {
    const { siteSettings } = useSiteSettingsStore(["siteSettings"])
    const announcementBar = siteSettings?.announcementBar
    const hasAnnouncementSlides = announcementBar?.slides?.length > 0

    const heroSliderHeight = hasAnnouncementSlides
    ? 'h-[calc(100dvh-45px)] md:h-[calc(100vh-30px)]'
    : 'h-[100dvh] mt-[35px] md:mt-[0]'

	return (
    <Carousel
      className={`hero-slider w-[calc(100%-10px)] md:w-[calc(100%-20px)] lg:w-full -ml-[5px] md:ml-[10px] lg:-ml-0 ${heroSliderHeight}`}
      settings={{ ...sliderSettings, numberOfSlides: slides?.length }}
      heading={title}
    >
      {slides?.filter(slide => isVisibleIn(slide.visibilityRegions))?.map((slide, i) => (
        <Hero key={i} {...{ ...slide, isSlider: true, isCentered: false, fromHeroSlider:true }} />
      ))}
    </Carousel>
  )
}
export default HeroSlider